import TargetsSctoMap from "./TargetsSctoMap";

export default TargetsSctoMap;
